import {
  Booking,
  ClientDashboard,
  ConfirmBookingPage,
  Details,
  Explore,
  FamilyMembers,
  Favorites,
  SavedCards,
  Credits,
  Memberships,
  Invoices,
  EmailPreferences,
  Documents,
  Workouts,
  Orders,
  InstallmentsCardUpdate,
  PaymentPage,
  PostBookingConfirmation,
  RescheduleAppointment,
  Waiver,
} from '../pages';

import OrderDetailsPage from '../pages/afterLogin/Orders/OrderDetailsPage';
import ResetPassword from '../pages/ResetPassword/index';

const routeConfig = [
  {
    path: ['/', '/dashboard'],
    component: ClientDashboard,
    name: 'Dashboard',
    exact: true,
  },
  {path: '/booking', component: Booking, name: 'Booking', exact: true},
  {
    path: '/reschedule',
    component: RescheduleAppointment,
    name: 'Reschedule',
    exact: true,
  },
  {
    path: '/confirm-booking',
    component: ConfirmBookingPage,
    name: 'Confirm Booking',
    exact: true,
  },
  {
    path: '/installment-card-update/:id',
    component: InstallmentsCardUpdate,
    name: 'Card Update',
    exact: true,
  },
  {
    path: '/family-members/:isBooking?',
    component: FamilyMembers,
    name: '',
    exact: true,
  },
  {path: '/explore', component: Explore, name: 'Explore', exact: true},
  {path: '/favorites', component: Favorites, name: 'Favorites', exact: true},
  {path: '/credits', component: Credits, name: 'Credits', exact: true},
  {
    path: [
      '/memberships',
      '/memberships/preview/:previewToken',
      '/memberships/:planId/agreement/:subscriberId',
      '/memberships/:planId/cancel-free-trial',
      '/memberships/:planId/cancel-membership',
      '/memberships/:planId/payment',
      '/memberships/:planId',
    ],
    component: Memberships,
    name: 'Memberships',
    exact: true,
  },
  {
    path: ['/invoices', '/invoices/:invoiceId'],
    component: Invoices,
    name: 'Invoices',
    exact: true,
  },
  {path: '/orders', component: Orders, name: 'Orders', exact: true},
  {path: '/documents', component: Documents, name: 'Documents', exact: true},
  {path: '/workouts', component: Workouts, name: 'Workouts', exact: true},
  {path: '/saved-cards', component: SavedCards, name: 'Saved Cards', exact: true},
  {
    path: '/email-preferences',
    component: EmailPreferences,
    name: 'Email Preferences',
    exact: true,
  },
  {path: '/reset-password', component: ResetPassword, name: 'Reset Password', exact: true},
  {path: '/details/:companyId', component: Details, name: '', exact: true},
  {path: '/payment', component: PaymentPage, name: 'Payment', exact: true},
  {
    path: '/order-details',
    component: OrderDetailsPage,
    name: 'Order Details',
    exact: true,
  },
  {
    path: '/booking-confirmation/:appointmentId?',
    component: PostBookingConfirmation,
    name: 'Booking Confirmation',
    exact: true,
  },
  {
    path: '/waiver',
    component: Waiver,
    name: 'Waiver',
    exact: true,
  },
];

export default routeConfig;
